import React, { useState } from 'react';

import Styles from "./App.module.css";

import baseimage from "./assets/base.png"

import background_01 from "./assets/background_01.png"
import background_02 from "./assets/background_02.png"
import background_03 from "./assets/background_03.png"
import background_04 from "./assets/background_04.png"
import background_05 from "./assets/background_05.png"
import background_06 from "./assets/background_06.png"
import background_07 from "./assets/background_07.png"
import background_08 from "./assets/background_08.png"
import background_09 from "./assets/background_09.png"
import background_10 from "./assets/background_10.png"
import background_11 from "./assets/background_11.png"
import background_12 from "./assets/background_12.png"

import dialog_01 from "./assets/dialog_01.png"
import dialog_02 from "./assets/dialog_02.png"
import dialog_03 from "./assets/dialog_03.png"
import dialog_04 from "./assets/dialog_04.png"
import dialog_05 from "./assets/dialog_05.png"
import dialog_06 from "./assets/dialog_06.png"
import dialog_07 from "./assets/dialog_07.png"
import dialog_08 from "./assets/dialog_08.png"
import dialog_09 from "./assets/dialog_09.png"
import dialog_02en from "./assets/dialog_02en.png"
import dialog_03en from "./assets/dialog_03en.png"
import dialog_04en from "./assets/dialog_04en.png"
import dialog_05en from "./assets/dialog_05en.png"
import dialog_06en from "./assets/dialog_06en.png"
import dialog_07en from "./assets/dialog_07en.png"
import dialog_08en from "./assets/dialog_08en.png"
import dialog_09en from "./assets/dialog_09en.png"

import face_01 from "./assets/face_01.png"
import face_02 from "./assets/face_02.png"
import face_03 from "./assets/face_03.png"
import face_04 from "./assets/face_04.png"
import face_05 from "./assets/face_05.png"
import face_06 from "./assets/face_06.png"
import face_07 from "./assets/face_07.png"
import face_08 from "./assets/face_08.png"
import face_09 from "./assets/face_09.png"

import option_01 from "./assets/option_01.png"
import option_02 from "./assets/option_02.png"
import option_03 from "./assets/option_03.png"
import option_04 from "./assets/option_04.png"
import option_05 from "./assets/option_05.png"
import option_06 from "./assets/option_06.png"
import option_07 from "./assets/option_07.png"
import option_08 from "./assets/option_08.png"
import option_09 from "./assets/option_09.png"
import option_10 from "./assets/option_10.png"
import option_11 from "./assets/option_11.png"
import option_12 from "./assets/option_12.png"
import option_13 from "./assets/option_13.png"
import option_14 from "./assets/option_14.png"
import option_15 from "./assets/option_15.png"
import option_16 from "./assets/option_16.png"
import option_17 from "./assets/option_17.png"
import option_18 from "./assets/option_18.png"
import option_19 from "./assets/option_19.png"
import option_20 from "./assets/option_20.png"
import option_21 from "./assets/option_21.png"
import option_22 from "./assets/option_22.png"
import option_23 from "./assets/option_23.png"
import option_24 from "./assets/option_24.png"
import option_25 from "./assets/option_25.png"
import option_26 from "./assets/option_26.png"
import option_27 from "./assets/option_27.png"
import option_28 from "./assets/option_28.png"
import option_29 from "./assets/option_29.png"
import option_30 from "./assets/option_30.png"
import option_31 from "./assets/option_31.png"
import option_32 from "./assets/option_32.png"
import option_33 from "./assets/option_33.png"
import option_34 from "./assets/option_34.png"
import option_35 from "./assets/option_35.png"
import option_36 from "./assets/option_36.png"
import option_37 from "./assets/option_37.png"
import option_38 from "./assets/option_38.png"
import option_39 from "./assets/option_39.png"
import option_40 from "./assets/option_40.png"
import option_41 from "./assets/option_41.png"
import option_42 from "./assets/option_42.png"
import option_43 from "./assets/option_43.png"
import option_44 from "./assets/option_44.png"
import option_45 from "./assets/option_45.png"
import option_46 from "./assets/option_46.png"
import option_47 from "./assets/option_47.png"
import option_48 from "./assets/option_48.png"
import option_49 from "./assets/option_49.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faCaretRight, faSpinner } from "@fortawesome/free-solid-svg-icons";

function App() {

  var backgrounds = [
    background_01, background_02, background_03, background_04, background_05, background_06, background_07, background_08, background_09, background_10,
    background_11, background_12
  ]

  var dialogs = [
    dialog_01, dialog_02, dialog_02en, dialog_03, dialog_03en, dialog_04, dialog_04en, dialog_05, dialog_05en, 
    dialog_06, dialog_06en, dialog_07, dialog_07en, dialog_08, dialog_08en, dialog_09, dialog_09en,
  ]

  var faces = [
    face_01, face_02, face_03, face_04, face_05, face_06, face_07, face_08, face_09,
  ]

  var options = [
    option_01, option_02, option_03, option_04, option_05, option_06, option_07, option_08, option_09, option_10,
    option_11, option_12, option_13, option_14, option_15, option_16, option_17, option_18, option_19, option_20,
    option_21, option_22, option_23, option_24, option_25, option_26, option_27, option_28, option_29, option_30,
    option_31, option_32, option_33, option_34, option_35, option_36, option_37, option_38, option_39, option_40,
    option_41, option_42, option_43, option_44, option_45, option_46, option_47, option_48, option_49,
  ].reverse()

  var optionsLabels = [
    "Collar", "Vest", "Vest 2", "Condom 1", "Condom 2", "Condom 3", "School Uniform", "Cuffs", "Paw Top", "Skirt",
    "Shorts", "Thigh Highs", "Sukimizu Cut", "Gloves", "Condom Ring", "Spats", "Panties", "Condom In", "Bra", "Breath",
    "Bunny Ears", "Yellow Top", "Yellow Panties", "Yellow Top 2", "Yellow panties 2", "Bunnysuit Open", "Bunnysuit", "Voyeur", "Voyeur Naked", "Blue Top",
    "Pink Top", "Blue Shorts", "Pink Shorts", "High Waist", "Sukimizu Down", "Sukimizu", "Towel Small", "Towel", "Slingkini 1", "Slingkini 2",
    "Slingkini 3", "Slipped Pastie", "Nipple Pasties", "Pastie", "Nipple Pasties 2", "Croch Tattoo", "Body Writing", "Body Writing 2", "Bush"
  ].reverse()

  var [backgroundindex, setBackgroundindex] = useState<number>(2);
  var [faceindex, setFaceindex] = useState<number>(0);
  var [dialogindex, setDialogindex] = useState<number>(0);
  var [downloading, setDownloading] = useState<boolean>(false);

  var [optionsEnabled, setOptionsEnabled] = useState<boolean[]>(new Array(options.length).fill(false));

  var mergeOptions = {
    format: 'image/png',
    quality: 0.92,
    width: undefined,
    height: undefined,
    Canvas: undefined,
    crossOrigin: "anonymous"
  };

  // Return Promise
  var mergeImages = (sources: string[]) => {
    if(sources === void 0) sources = [];

    return new Promise(function (resolve) {
      // Setup browser/Node.js specific variables
      var canvas = window.document.createElement('canvas');
      var Image = window.Image;

      // Load sources
      var images = sources.map((source: any) => {
        return new Promise(function (resolve, reject) {
          // Convert sources to objects
          if(source.constructor.name !== 'Object') {
            source = { src: source };
          }

          // Resolve source and img when loaded
          var img = new Image();
          img.crossOrigin = mergeOptions.crossOrigin;
          img.onerror = function () { return reject(new Error('Couldn\'t load image')); };
          img.onload = function () { return resolve(Object.assign({}, source, { img: img })); };
          img.src = source.src;
        });
      });

      // Get canvas context
      var ctx = canvas.getContext('2d');

      // When sources have loaded
      resolve(Promise.all(images)
        .then(function (images: any[]) {
          // Set canvas dimensions
          var getSize = (dim: "width" | "height") => {
            return mergeOptions[dim] || Math.max.apply(Math, images.map(function (image) { return image.img[dim]; }));
          };
          canvas.width = getSize('width');
          canvas.height = getSize('height');

          // Draw images to canvas
          images.forEach(function (image) {
            (ctx as any).globalAlpha = image.opacity ? image.opacity : 1;
            return (ctx as any).drawImage(image.img, image.x || 0, image.y || 0);
          });

          // Resolve all other data URIs sync
          var dataUrl = canvas.toDataURL(mergeOptions.format, mergeOptions.quality);
          return dataUrl;
        }));
    });
  };

  const onCheck = (index: number) => {
    var newOptionsEnabled = [...optionsEnabled];
    newOptionsEnabled[index] = !newOptionsEnabled[index];
    setOptionsEnabled(newOptionsEnabled);
  }

  const onBg = (left: boolean) => {
    setBackgroundindex(backgroundindex = ((left ? (backgroundindex - 1) : (backgroundindex + 1)) + backgrounds.length) % backgrounds.length);
  }

  const onFace = (left: boolean) => {
    setFaceindex(faceindex = ((left ? (faceindex - 1) : (faceindex + 1)) + faces.length) % faces.length);
  }

  const onDialog = (left: boolean) => {
    setDialogindex(dialogindex = ((left ? (dialogindex - 1) : (dialogindex + 1)) + dialogs.length) % dialogs.length);
  }

  const download = () => {
    if(downloading)
      return;
    setDownloading(true);

    var sources = [
      backgrounds[backgroundindex],
      baseimage,
      faces[faceindex],
      dialogs[dialogindex]
    ]

    for(var i = 0; i < options.length; i++)
      if(optionsEnabled[i])
        sources.push(options[i])

    mergeImages(sources)
      .then(b64 => {
        var link = document.createElement("a");
        link.download = "fumina.png";
        link.href = b64 as string;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDownloading(false);
      });
  }

  const getTableRows = () => {
    const rows = [];
    for(let i = 0; i < options.length; i += 3) {
      rows.push(<tr>
        <td>
          <div>
            <input type="checkbox" onChange={() => onCheck(i)} />
            <div>{optionsLabels[i]}</div>
          </div>
        </td>
        <td>
          {i + 1 < options.length &&
            <div>
              <input type="checkbox" onChange={() => onCheck(i + 1)} />
              <div>{optionsLabels[i + 1]}</div>
            </div>
          }
        </td>
        <td>
          {i + 2 < options.length &&
            <div>
              <input type="checkbox" onChange={() => onCheck(i + 2)} />
              <div>{optionsLabels[i + 2]}</div>
            </div>
          }
        </td>
      </tr>)
    }

    return rows;
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.flexrow}>
        <div className={Styles.imagecontainer}>
          {backgrounds.map((x, i) => {
            return (
              <div className={[Styles.image, backgroundindex !== i && Styles.hide].join(" ")}>
                <img src={x} alt="" key={"background-" + i} />
              </div>
            );
          })}
          <div className={Styles.image}>
            <img src={baseimage} alt="" />
          </div>
          {faces.map((x, i) => {
            return (
              <div className={[Styles.image, faceindex !== i && Styles.hide].join(" ")}>
                <img src={x} alt="" key={"face-" + i} />
              </div>
            );
          })}
          {dialogs.map((x, i) => {
            return (
              <div className={[Styles.image, dialogindex !== i && Styles.hide].join(" ")}>
                <img src={x} alt="" key={"dialog-" + i} />
              </div>
            );
          })}
          {options.map((x, i) => {
            return (
              <div className={[Styles.image, !optionsEnabled[i] && Styles.hide].join(" ")}>
                <img src={x} alt="" key={"option-" + i} />
              </div>
            );
          })}
        </div>
        <div className={Styles.options}>
          <table>
            <tbody>
              {getTableRows()}
            </tbody>
          </table>
          <div className={Styles.divider}></div>
          <div className={Styles.optionrow}>
            <button className={Styles.button} onClick={() => onBg(true)}><FontAwesomeIcon icon={faCaretLeft} /></button>
            <div>{String(backgroundindex).padStart(2, '0')}</div>
            <button className={Styles.button} onClick={() => onBg(false)}><FontAwesomeIcon icon={faCaretRight} /></button>
            <div>Background</div>
          </div>
          <div className={Styles.optionrow}>
            <button className={Styles.button} onClick={() => onFace(true)}><FontAwesomeIcon icon={faCaretLeft} /></button>
            <div>{String(faceindex).padStart(2, '0')}</div>
            <button className={Styles.button} onClick={() => onFace(false)}><FontAwesomeIcon icon={faCaretRight} /></button>
            <div>Face</div>
          </div>
          <div className={Styles.optionrow}>
            <button className={Styles.button} onClick={() => onDialog(true)}><FontAwesomeIcon icon={faCaretLeft} /></button>
            <div>{String(dialogindex).padStart(2, '0')}</div>
            <button className={Styles.button} onClick={() => onDialog(false)}><FontAwesomeIcon icon={faCaretRight} /></button>
            <div>Dialog</div>
          </div>
          <div className={Styles.divider}></div>
          <button className={[Styles.download, downloading && Styles.disabled].join(" ")} onClick={() => download()}>
            {downloading ? <FontAwesomeIcon icon={faSpinner} className={Styles.spinner} /> : "Download"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
